import {Component, OnInit} from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { API_ServerAddress } from 'src/app/MyAppCommonConfig';

@Component({
    selector:'doctorsAnswering',
     templateUrl:'doctorsAnswering.component.html'
})
export class DoctorsAnsweringComponent implements OnInit{

    ngOnInit(): void {
        this.SetPageMetaData();
    }

    laboratoriesAnsweringLink: string = '';

    constructor(private titleService: Title, private metaService: Meta, private sanitizer: DomSanitizer) {
        this.laboratoriesAnsweringLink = API_ServerAddress + '/OnlineServices/Doctors';
    }

    SetPageMetaData() {
        this.titleService.setTitle('جوابدهی پزشکان همکار');
        this.metaService.updateTag({ name: 'description', content: 'جوابدهی پزشکان همکار' });
        this.metaService.updateTag({ name: 'keywords', content: 'جوابدهی پزشکان همکار' });
    }

    getSefeUrl(){
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.laboratoriesAnsweringLink);
    }
}